module.exports = __webpack_public_path__ + "static/media/padlock-icon.d40245dc.svg";